import { useNavigate } from "react-router-dom"
import { pageRoutes } from "../dictionary"
import cta from '../../../custom_assets/home/home-cta.jpg'
import { HomepageReactGAHandlers } from "../ReactGAHandlers"

export const CTA = ({ user }) => {

  const { handleHomepageClick } = HomepageReactGAHandlers()
  let navigate = useNavigate()

  const ctaButton = <button
    className="dca-home-cta-component-button"
    onClick={() => {
      handleHomepageClick('CTA Bottom');
      navigate(pageRoutes.dashboard)
    }}
    style={{ width: user?.dashboardAlertShown == true ? '216px' : '180px' }}>

    {user?.dashboardAlertShown == true ? <span className="d-flex flex-row justify-content-center align-items-center" style={{ whiteSpace: 'nowrap' }}>My Dashboard <i
      className="fa-solid fa-arrow-right"
      style={{
        color: 'black',
        fontWeight: 'bold',
        paddingLeft: '8px',
        fontSize: '1.2rem'
      }}></i></span> : 'Get Started'}

  </button>

  return <div className="dca-home-cta-container" style={{ backgroundImage: `url(${cta})` }}>
    <span className="dca-home-cta-text">Get an edge in your college admissions journey</span>
    {ctaButton}
  </div>
}